import { render, staticRenderFns } from "./PfandSetting.vue?vue&type=template&id=d0b65dae&scoped=true"
import script from "./PfandSetting.vue?vue&type=script&lang=js"
export * from "./PfandSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b65dae",
  null
  
)

export default component.exports